// intakeAnimalsLabel — pure display helper for the staff requests surface.
//
// Kept in its own dependency-free module (no network/Vite imports) so it is
// unit-testable under `node --test` / tsx without pulling in authService's
// import.meta.env access.

import type { RequestStatus } from './requestsClient';

/**
 * Label for an intake_animals request whose collected animal list is EMPTY.
 * An empty list is ambiguous on its own, so the copy depends on the request
 * status:
 *   • completed — the applicant affirmatively answered "no animals". Say so,
 *     rather than the bug-looking "not recorded yet" (which made a perfectly
 *     valid declared-none read like missing data — WEL-54).
 *   • anything else (still outstanding) — there genuinely is no answer yet.
 */
export function animalsEmptyLabel(status: RequestStatus): string {
  return status === 'completed'
    ? 'Completed — the applicant declared they have no animals.'
    : 'No animals recorded yet.';
}
